import React from 'react';
import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import { Card } from '@material-ui/core';
import { TranslateProvider } from '../../containers/TranslationsProvider';
import { getPrimary, primary } from '../../styles/colors';
import backgroundLogin from '../../assets/img/Group@1,5x.jpg';
import {
	BasicButton,
	ButtonIcon,
	Grid,
	GridItem,
	TextInput
} from '../../UI';
import { MainAppContext } from '../../containers/MainAppProvider';
import HeaderRoot from '../Manager/HeaderRoot';
import CBXFooter from '../Manager/CBXFooter';
import { isMobile } from '../../utils/screen';
import withWindowSize from '../../HOCs/withWindowSize';


const LoginPage = ({ windowSize }) => {
	const [state, setState] = React.useState({
		user: '',
		password: '',
		loading: false,
		showPassword: false,
		errors: {
			user: '',
			password: ''
		}
	});
	const client = useApolloClient();
	const mainAppContext = React.useContext(MainAppContext);
	const translate = React.useContext(TranslateProvider);


	const checkRequiredFields = () => {
		const errors = {
			user: '',
			password: ''
		};

		let hasError = false;

		if (!state.user) {
			hasError = true;
			errors.user = translate.field_required;
		}

		if (!state.password) {
			hasError = true;
			errors.password = translate.field_required;
		}

		setState({
			...state,
			errors
		});

		return hasError;
	};

	const login = async () => {
		const { user, password } = state;
		const checkFields = checkRequiredFields();
		if (!checkFields) {
			setState({
				loading: true
			});
			const response = await client.mutate({
				mutation: gql`
				mutation Login($email: String!, $password: String!) {
					login(email: $email, password: $password) {
						token
						refreshToken
					}
				}
			`,
				variables: {
					email: user,
					password
				}
			});


			if (response.errors) {
				const errors = {
					'Incorrect password': () => {
						setState({
							loading: false,
							errors: {
								password: translate.password_err
							}
						});
					},

					'Not actived': () => {
						setState({
							loading: false,
							errors: {
								user: translate.email_not_found
							}
						});
					},

					'Not found': () => {
						setState({
							loading: false,
							errors: {
								user: translate.email_not_found
							}
						});
					},

					'Invalid domain': () => {
						setState({
							loading: false,
							errors: {
								user: translate.domain_invalid_creds
							}
						});
					},

					'Unsubscribed account': () => {
						setState({
							loading: false,
							errors: {
								user: 'Cuenta deshabilitada' // TRADUCCION
							}
						});
					},

					'User not registered or incorrect password': () => {
						setState({
							loading: false,
							errors: {
								user: 'Usuario no registrado o contraseña incorrecta' // TRADUCCION
							}
						});
					}
				};

				return errors[response.errors[0].message] ? errors[response.errors[0].message]() : null;
			}
			if (!response.data.login) {
				setState({
					loading: false,
					errors: {
						user: 'Error en la petición al servidor, inténtalo de nuevo mas tarde' // TRADUCCION
					}
				});
			}

			sessionStorage.setItem('token', response.data.login.token);
			sessionStorage.setItem('refreshToken', response.data.login.refreshToken);

			const getMe = gql`
			query Me {
				me {
					roles
				}
			}
			`;
			const checkUserRoles = await client.query({
				query: getMe,
				errorPolicy: 'all'
			});

			if (!['root', 'devAdmin'].includes(checkUserRoles?.data?.me?.roles)) {
				setState({
					loading: false,
					errors: {
						user: 'Usuario sin los permisos necesarios' // TRADUCCION
					}
				});
				mainAppContext.logout();
				return false;
			}

			mainAppContext.loginSuccess();
			return true;
		}
		return checkFields;
	};

	const handleKeyUp = event => {
		if (event.nativeEvent.keyCode === 13) {
			login();
		}
	};

	const logged = () => (
		<div style={{ padding: '.5rem' }}>
			<form>
				<div
					style={{
						marginTop: '2em',
					}}
				>
					<TextInput
						onKeyUp={handleKeyUp}
						id={'username'}
						floatingText={translate.login_user}
						type='text'
						value={state.user}
						onChange={event => setState({
							...state,
							user: event.target.value
						})
						}
						errorText={state?.errors?.user}
					/>
				</div>
				<div
					style={{
						marginTop: '1.5em',
					}}
				>
					<TextInput
						floatingText={translate.login_password}
						id={'password'}
						type={
							state.showPassword
								? 'text'
								: 'password'
						}
						passwordToggler={() => setState({
							...state,
							showPassword: !state.showPassword
						})
						}
						showPassword={state.showPassword}
						onKeyUp={handleKeyUp}
						value={state.password}
						onChange={event => setState({
							...state,
							password: event.nativeEvent.target.value
						})
						}
						errorText={state?.errors?.password}
					/>
				</div>
			</form>
			<div style={{ marginTop: '3em' }}>
				<BasicButton
					text={translate.dashboard_enter}
					color={primary}
					loading={state.loading}
					id={'login-button'}
					textStyle={{
						color: 'white',
						fontWeight: '700'
					}}
					textPosition='before'
					onClick={login}
					fullWidth={true}
					icon={
						<ButtonIcon
							color='white'
							type='arrow_forward'
						/>
					}
				/>
			</div>
			<div style={{ marginTop: '5em' }}>
				<CBXFooter />
			</div>
		</div>
	);

	return (

		<div style={{
			width: '100%',
			background: `url('${backgroundLogin}') no-repeat`,
			backgroundSize: 'cover',
			display: 'flex',
			flexDirection: 'column',
		}}>
			<HeaderRoot />
			<Grid style={{
				width: '100%',
				overflowX: 'hidden',
				padding: '0',
				margin: '0',
				height: '100%'
			}}>
				<GridItem xs={12} md={7} lg={7}
				>
				</GridItem>
				<GridItem lg={5} md={5} xs={12}
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						padding: '3em',
						margin: '0',
						height: !isMobile && '100%',
						width: '100%',
					}}
				>
					<Card elevation={6}
						style={{
							minHeight: '60%',
							width: windowSize === 'xs' ? '100vw' : '70%',
							padding: '8%',
							paddingBottom: '1em',
							margin: '0',
							position: 'relative',
							marginBottom: windowSize === 'xs' ? 0 : '5em',
							marginRight: windowSize === 'xs' ? 0 : '5em'
						}}>
						<div
							style={{
								marginBottom: '0px',
								paddingBottom: '0px',
								fontWeight: '700',
								fontSize: '1.3em',
								color: getPrimary(),
							}}
						>
							Iniciar sesión
						</div>
						{logged()}
					</Card>
				</GridItem>
			</Grid>
		</div >

	);
};


export default withWindowSize(LoginPage);
